// ── Persistent device token ───────────────────────────────────────
// Primary device identifier — a UUID stored in localStorage.
// More reliable than hardware fingerprint alone.
export function getDeviceToken() {
  const KEY = 'cf_device_token'
  let token = localStorage.getItem(KEY)
  if (!token) {
    token = 'dt_' + ([1e7]+-1e3+-4e3+-8e3+-1e11)
      .toString()
      .replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
    localStorage.setItem(KEY, token)
  }
  return token
}

// ── Hardware fingerprint (backup) ────────────────────────────────
export function getDeviceFingerprint() {
  const raw = [
    navigator.userAgent, navigator.language,
    screen.width + 'x' + screen.height, screen.colorDepth,
    new Date().getTimezoneOffset(),
    navigator.hardwareConcurrency || 0,
    navigator.platform || '',
  ].join('|')
  let hash = 0
  for (let i = 0; i < raw.length; i++) {
    const chr = raw.charCodeAt(i)
    hash = ((hash << 5) - hash) + chr
    hash |= 0
  }
  return 'fp_' + Math.abs(hash).toString(36)
}

// ── GPS ───────────────────────────────────────────────────────────
export function getCurrentPosition(options = {}) {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error('Geolocation is not supported by this browser.'))
      return
    }
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: true,
      timeout: 12000,
      maximumAge: 0,
      ...options,
    })
  })
}

// ── Offline queue ─────────────────────────────────────────────────
// Stores failed submissions locally and retries when online
const QUEUE_KEY = 'cf_attendance_queue'

export function queueAttendance(payload) {
  const queue = JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]')
  queue.push({ ...payload, queued_at: new Date().toISOString() })
  localStorage.setItem(QUEUE_KEY, JSON.stringify(queue))
}

export function getQueue() {
  return JSON.parse(localStorage.getItem(QUEUE_KEY) || '[]')
}

export function clearQueue() {
  localStorage.removeItem(QUEUE_KEY)
}
